<template>
  <div>
    <el-row v-for="room in value" :key="room.idRoomsForBooking" :style="(value.length>0)?'border-bottom: 1px dotted #c3bdbd;':''">
      <el-col :sm="24" :md="11" style="width: 170px;">
        {{room.roomtype}}
        <small>{{room.roomname}}</small>
      </el-col>
      <el-col :sm="11" :md="6" style="width: 80px;">{{formatDate(room.arrivalDate)}}</el-col>
      <el-col :sm="2" :md="1" style="width: 30px;">
        <i class="material-icons">keyboard_arrow_right</i>
      </el-col>
      <el-col :sm="11" :md="6" style="width: 80px;">{{formatDate(room.departureDate)}}</el-col>
    </el-row>
  </div>
</template>

<script>
import { fetchList } from "~/api/resource";
import { mapGetters } from "vuex";

export default {
  name: "v-rooms",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  }
};
</script>
